module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6cba5a4b68e3a1b226e2f95393d04e29.png";